angular.module('assets')
    .component('assetAcquisitionSelect', {
        require: {
            ngModelCtrl: 'ngModel'
        },
        bindings: {
            required: "<?",
            onChange: "&"
        },
        template: `
            <select class="form-control input-sm" id="acquisition" name="acquisition" ng-model="$ctrl.selected" ng-change="$ctrl.onSelectionChanged($ctrl.selected)" empty-to-null ng-required="$ctrl.required">
                <option translate="select.choose"></option>
                <option value="{{c}}" ng-repeat="c in $ctrl.items">{{'asset.acquisition.'+c|translate}}</option>
            </select>
        `,
        controller: function() {
            const ctrl = this;

            ctrl.$onInit = () => {
                ctrl.required = ctrl.required || false;
                ctrl.items = [ 'PURCHASE', 'RENT' ]

                ctrl.ngModelCtrl.$render = () => ctrl.selected = ctrl.ngModelCtrl.$viewValue;
                ctrl.ngModelCtrl.$formatters.push(modelValue => modelValue);
                ctrl.ngModelCtrl.$parsers.push(viewValue => viewValue);
            };

            ctrl.onSelectionChanged = ($item) => {
                ctrl.ngModelCtrl.$setViewValue($item);
                ctrl.ngModelCtrl.$validate();
                ctrl.ngModelCtrl.$render();
                if (angular.isFunction(ctrl.onChange())) {
                    ctrl.onChange()($item);
                }
            };
        }
    })
